import formAppDynamicProvider from "./formAppDynamicProvider";
import formAppDynamicProviderConfirmation from "./formAppDynamicProviderConfirmation";

export default {
  title: 'V.T. Dynamic provider',
  attributeName: 'appDynamicProvider',
  getURL: 'appId/appDynamicProvider',
  createURL: 'appId/appDynamicProvider',
  updateURL: 'appId/appDynamicProvider',
  sessionParams: ['appId'],
  idAttribute: 'appProviderId',
  formConfig: [formAppDynamicProvider,formAppDynamicProviderConfirmation],
  autoUpdate: true,
  noArea: true,
  goBack: true,
};
